import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class NewInstalledUnitsCountService {

    private NEWINSTALLEDUNITSCount_URL = 'api/newInstalledUnits/{days}'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.NEWINSTALLEDUNITSCount_URL;
    }

    getTankData$(days: string): Observable<ScalarResponseModel> {
        let x = this.url.replace('{days}', days);
        return this._httpClient.get<ScalarResponseModel>(`${x}`);
    }
}
